import Marquee from "react-fast-marquee";
import { REASSURANCE } from "@/lib/content";

export default function ReassuranceMarquee() {
  return (
    <section data-testid="reassurance-marquee" className="border-y border-line bg-sage/15 py-8">
      <Marquee speed={38} gradient={false} pauseOnHover>
        {REASSURANCE.map((msg, i) => (
          <span key={i} className="mx-10 inline-flex items-center gap-10">
            <span className="font-serif text-2xl italic text-sage sm:text-3xl">{msg}</span>
            <span className="h-1.5 w-1.5 rounded-full bg-terracotta/70" aria-hidden />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
